/* import __COLOCATED_TEMPLATE__ from './format-selected-content.hbs.js'; */
import Component from "@ember/component";
import { computed } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import { makeArray } from "discourse/lib/helpers";
import UtilsMixin from "select-kit/mixins/utils";
const FormatSelectedContent = dt7948.c(class FormatSelectedContent extends Component.extend(UtilsMixin) {
  content = null;
  selectKit = null;
  get formattedContent() {
    if (this.content) {
      return makeArray(this.content).map(c => this.getName(c)).join(", ");
    } else {
      return this.getName(this.selectKit.noneItem);
    }
  }
  static {
    dt7948.n(this.prototype, "formattedContent", [computed("content")]);
  }
}, [tagName("")]);
export default FormatSelectedContent;